import { toJS } from "mobx";

export class EntityUpdater {
    constructor(data) {
        this.data = toJS(data);
        this.starting = data.numberOfStartingPlayers;
    }

    processDeletions(deleting, targetObject) {
        const teamStartingCounters = {};
        let teamId = null;
        deleting.forEach((item) => {
            if (item.isStartingPlayer) {
                teamId = targetObject[item.id].team;
                if (!teamStartingCounters[teamId]) {
                    teamStartingCounters[teamId] = 1;
                } else {
                    teamStartingCounters[teamId]++;
                }
            }
            targetObject = {
                ...targetObject,
                [item.id]: {
                    ...targetObject[item.id],
                    isDeleted: true,
                },
            };
        });

        const allPlayers = Object.values(targetObject).filter(
            (player, index) => {
                return player.team == teamId && !player.isStartingPlayer;
            }
        );

        allPlayers.forEach((player, index) => {
            if (index < teamStartingCounters[teamId]) {
                targetObject[player.contact] = {
                    ...player,
                    isStartingPlayer: true,
                    isChanged: true,
                };
            }
        });

        return targetObject;
    }

    processAdditions(adding, targetObject, transformFunc) {
        adding.forEach((item) => {
            targetObject = {
                ...targetObject,
                [item.id]: transformFunc(item),
            };
        });
        return targetObject;
    }
}
